import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';

import * as R from 'ramda';
import { BrazeOptinRow } from './BrazeOptinRow';
import { useFeature } from 'flagged';

const brazeStyles = require('./braze.css');

export const BrazeSubscriptionGroupOptins = ({
  account,
  enumerations,
  setTabSaving,
  handleOptinActiveChange,
  decommissioningCommenced,
}) => {
  const brazeLineOptinsEnabled = useFeature('braze-line-optins');
  const channels = enumerations.enumerations.brazeSubscriptionGroupChannels;

  let _channelsCodes = Object.keys(channels);
  if (!brazeLineOptinsEnabled) {
    _channelsCodes = _channelsCodes.filter(
      (code) => channels[code].value !== 'line'
    );
  }
  const [channelsCodes, setChannelsCodes] = useState(_channelsCodes);

  const _handleOptinActiveChange = (target: string, isActive: boolean) => {
    handleOptinActiveChange(target, isActive);
    const code = channelsCodes.find(
      ($) => `${account.account_id}_${channels[$].value}` === target
    );
    channels[code].active = isActive;
  };

  const subscriptionGroupRows = channelsCodes
    .sort((a, b) => channels[b].active - channels[a].active)
    .map((channelCode) => {
      const channel = channels[channelCode];
      return (
        <BrazeOptinRow
          channel={channel}
          account={account}
          enumerations={enumerations}
          setTabSaving={setTabSaving}
          showSubscriptionGroup={true}
          key={channel.value}
          handleOptinActiveChange={_handleOptinActiveChange}
          decommissioningCommenced={decommissioningCommenced}
        />
      );
    }, channelsCodes);

  return (
    <React.Fragment>
      <Row className={brazeStyles.optinEnabledRowHeader}>
        <Col sm={10}>
          <h4>Subscription Group Optins</h4>
        </Col>
      </Row>
      {subscriptionGroupRows}
    </React.Fragment>
  );
};
